import { render, staticRenderFns } from "./PedidoRealizado.vue?vue&type=template&id=077e06b6&scoped=true&"
import script from "./PedidoRealizado.vue?vue&type=script&lang=js&"
export * from "./PedidoRealizado.vue?vue&type=script&lang=js&"
import style0 from "./PedidoRealizado.vue?vue&type=style&index=0&id=077e06b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077e06b6",
  null
  
)

export default component.exports